import type { CardTextualItemData } from 'src/types/cardTextual2'
import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'

interface Props {
  item: CardTextualItemData
  fullWidthMobile?: boolean
}

export default function CardTextualItem({
  item,
  fullWidthMobile = false,
}: Props) {
  const mobileWidthClass = fullWidthMobile ? 'w-full' : 'w-[256px] snap-start'

  return (
    <article
      data-testid="card-textual-item"
      className={`flex min-h-[414px] max-h-[414px] ${mobileWidthClass} flex-col border border-solid border-restructure-border-card bg-restructure-background-neutral-3 p-[30px] md:min-h-[314px] md:max-h-[317.91px] md:w-full md:max-w-[465.33px]`}
    >
      <div className="w-fit rounded-full bg-primaryBlue px-4 py-2 md:bg-white">
        <p className="text-xs font-extrabold uppercase tracking-[0.04em] text-white md:text-primaryBlue">
          {item.flag}
        </p>
      </div>

      <h3 className="mt-8 text-[30px] font-extrabold leading-[32.4px] tracking-[-0.015em] text-primaryBlue md:text-[27px] md:leading-[29px]">
        {item.title}
      </h3>

      <p className="mt-4 text-[15px] leading-[1.6] text-restructure-neutral-22">
        {item.text}
      </p>

      <div className="mt-auto pt-[29px] md:pt-[30px]">
        <FlexibleLink
          linkUrl={item.buttonLink}
          classNames="inline-flex h-[45.5px] w-fit items-center rounded-full bg-primaryBlue px-[26px] pt-[1px] text-[14.5px] font-bold text-white transition-colors hover:bg-restructure-blue-7 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primaryBlue focus-visible:ring-offset-2"
        >
          {item.buttonLabel}
        </FlexibleLink>
      </div>
    </article>
  )
}
